import { Server } from "lucide-react";
import type { FpMessagePart } from "../../../../../schemas/codegen";
import { ExpandableMessageCard, SimpleMessageCard } from "./shared";

interface McpToolsProps {
  part: Extract<FpMessagePart, { type: "tool-call" }>;
}

export function McpTools({ part }: McpToolsProps) {
  const isError = part.status === "error";

  const getDisplayName = () => {
    switch (part.toolName) {
      case "addMcpServer":
        return `Connecting to ${part.args?.name || "MCP server"}`;
      case "removeMcpServer":
        return "Disconnecting MCP server";
      case "listMcpServers":
        return "Listing MCP servers";
      default:
        return `MCP: ${part.toolName}`;
    }
  };

  if (isError) {
    return (
      <ExpandableMessageCard
        status={part.status}
        result={part.result}
        icon={Server}
        title={`Failed: ${getDisplayName()}`}
        accordionValue="mcp-tools"
      />
    );
  }

  return (
    <SimpleMessageCard
      status={part.status}
      icon={Server}
      title={getDisplayName()}
    />
  );
}
